<template>
  <span v-if="tag" class="produto-tag" :class="[`produto-tag-${tag.id}`, {'produto-tag-compacta': variant === 'compacta'}]">
    {{ tag.label }}
  </span>
</template>

<script>
export const PRODUTO_TAGS = Object.freeze({
  '1': 'Mais Vendido',
  '2': 'Novidade',
  '3': 'Recomendado',
  '4': 'Especial da Casa',
  '5': 'Edição Limitada'
});

export function getProdutoTag(idTag) {
  if (idTag === null || idTag === undefined) return null;

  const id = String(idTag).trim();
  return PRODUTO_TAGS[id] ? { id, label: PRODUTO_TAGS[id] } : null;
}

export default {
  name: 'ProdutoTag',
  props: {
    idTag: {
      type: [String, Number],
      default: null
    },
    variant: {
      type: String,
      default: ''
    }
  },
  computed: {
    tag() {
      return getProdutoTag(this.idTag);
    }
  }
};
</script>

<style scoped>
.produto-tag {
  display: inline-block;
  max-width: 100%;
  margin-bottom: 3px;
  padding: 4px 9px;
  overflow: hidden;
  border-radius: 7px;
  color: #c2410c;
  background-color: #ffedd5;
  font-size: 11px;
  font-weight: 700;
  line-height: 1.2;
  text-overflow: ellipsis;
  text-transform: uppercase;
  white-space: nowrap;
}

.produto-tag-2 {
  color: #2563eb;
  background-color: #dbeafe;
}

.produto-tag-3 {
  color: #15803d;
  background-color: #dcfce7;
}

.produto-tag-4 {
  color: #7c3aed;
  background-color: #ede9fe;
}

.produto-tag-5 {
  color: #db2777;
  background-color: #fce7f3;
}

.produto-tag-compacta {
  margin-bottom: 0;
  padding: 4px 6px;
  border-radius: 6px;
  font-size: 9px;
  font-weight: 600;
}
</style>
